import {Injectable} from '@angular/core';
import {Postfachadresse, StammdatenAdresse} from '@nachdigal';
import {AbstractMapper} from '../../abstract.mapper';

@Injectable()
export class PostfachadresseMapperService extends AbstractMapper<StammdatenAdresse, Postfachadresse> {

  public mapArray(source: Array<StammdatenAdresse>): Array<Postfachadresse> {
    return super.mapArray(source?.filter(value => value.typ === StammdatenAdresse.TypEnum.NUMBER_2));
  }

  public getMappedArrayDefaultIndex(source: Array<StammdatenAdresse>): number {
    return source.filter(value => value.typ === StammdatenAdresse.TypEnum.NUMBER_2)
      .findIndex(value => value.standard);
  }

  protected mapInternal(source: StammdatenAdresse): Postfachadresse {

    if (source.typ !== StammdatenAdresse.TypEnum.NUMBER_2) {
      return undefined;
    }

    return {
      postfach: source.postfach.postfach,
      ort: source.postfach.ort,
      postleitzahl: source.postfach.postfachpostleitzahl
    };
  }
}
